<template>
  <div class="w-full zt-h2-page">
    <div class="pl-2 !mb-4 xl:!pl-0" v-if="isGala && readyToShow && Number(isInSidebar)">
      <h2 class="">Bukmacher {{ isGala }}</h2>
    </div>
    <div :id="generatedId" class="w-full flex justify-center">
      <div v-if="!isGala && readyToShow" data-nosnippet
           class="w-[359px] h-[400px] relative -mx-4
             sm:w-[635px] md:mx-0 sm:h-[346px] xl:w-full xl:max-w-[832px] xl:h-[282px]">
        <BonusDetailsModal v-if="bookieData && isModalOpen"
                           :bookieData="bookieData"
                           :isBookieDataLoaded="isBookieDataLoaded"
                           :isMainBonus="true"
                           :isInSidebar="Number(isInSidebar) === 1"
                           @close-modal="closeModal" />
        <div v-if="window.size.width < 640"
             data-bg-img="url(/wp-content/themes/zawodtyper/assets/images/background_bilet-sm.webp)"
             class="w-[359px] h-[inherit] absolute !m-0 bg-no-repeat"></div>
        <div v-else-if="window.size.width < 1280"
             data-bg-img="url(/wp-content/themes/zawodtyper/assets/images/background-bilet-mobile.webp)"
             class="w-[635px] h-[inherit] absolute left-0 !m-0 bg-cover"></div>
        <div v-else class="w-full h-full absolute left-0 !m-0 shrink-0 flex flex-nowrap">
          <div data-bg-img="url(/wp-content/themes/zawodtyper/assets/images/bilet_tlo.webp)"
               class="grow h-full max-w-[698px] !bg-cover"
               :class="[ WP.categories[0]?.cat_ID === 12 ? ['td-cut-corners'] : 'cut-corners' ]"></div>
          <div data-bg-img="url(/wp-content/themes/zawodtyper/assets/images/bilet-kod.webp)"
               class="w-[134px] h-full"></div>
        </div>
        <div :data-bg-img="'url(/wp-content/themes/zawodtyper/assets/images/koszulki/' + bonusName + '.svg)'"
             class="relative h-[57px] bg-center bg-no-repeat rounded-t-2xl z-10 cursor-pointer zt-hover
               xl:rounded-tl-xl xl:rounded-tr-none xl:w-[calc(100%_-_134px)] xl:max-w-[698px]"
             :class="[WP.categories[0]?.cat_ID === 12 ? 'td-cut-corner' : 'cut-corner']"
             @click="handleLogoClick()"></div>
        <div class="flex flex-col mt-2 mb-5 justify-between h-[240px] gap-2 sm:gap-4 sm:h-auto xl:h-[185px] xl:w-[calc(100%_-_134px)] xl:mt-2.5 xl:gap-3">
          <div class="relative justify-center text-center font-medium z-10 mx-auto w-[80%] text-[26px] leading-[38px]
                 min-h-[117px] line-clamp-4 sm:min-h-[88px] xl:w-full xl:text-[32px] xl:leading-[44px] xl:px-4"
               :class="{ 'text-content xl:!text-[28px]': WP.categories[0]?.cat_ID === 12 }"
               v-html="text"></div>
          <div class="xl:w-full">
            <div v-if="type !== 'zawodtyper'"
                 class="relative h-[45px] cursor-pointer xl:h-[56px]"
                 @click="clickHandler(bonusLink)">
              <div class="bg-white text-2xl text-black font-medium px-10 py-1 border border-dashed border-black
                     absolute -translate-x-2/3 left-1/2 xl:text-[30px] xl:leading-6 xl:h-full xl:flex xl:align-middle xl:px-12">
                <p class="my-auto">{{ code }}</p>
              </div>
              <div class="shine-animation bg-zt-red rounded-zt py-[5px] px-4 !no-underline text-text zt-hover font-semibold
                     absolute left-1/2 translate-y-1 shadow-[0_2px_15px_0_rgba(196,12,12,.4)] overflow-hidden
                   active:text-text focus:text-text translate-x-[52px]
                     xl:text-xl xl:py-2 xl:px-7 xl:translate-y-[7px] xl:translate-x-[62px]"
                   @click="saveReceivedBonus()">
                ODBIERZ
              </div>
            </div>
            <div v-else class="relative h-[50px] cursor-pointer xl:h-[56px]" @click="clickHandler(bonusLink)">
                <div class="shine-animation bg-zt-red rounded-[5px] py-3 px-4 !no-underline text-text zt-hover font-semibold
                       shadow-[0_2px_15px_0_rgba(196,12,12,.4)] relative !overflow-hidden
                     active:text-text focus:text-text w-[244px] mx-auto text-center xl:px-7">
                    SPRAWDŹ BONUSY
                </div>
            </div>
          </div>
          <div v-if="bookieData" class="relative flex justify-center items-center">
            <span class="text-center underline text-zt-more font-medium leading-[30px] zt-hover cursor-pointer px-2"
                  @click="handleShowDetails(1)">POKAŻ SZCZEGÓŁY</span>
          </div>
        </div>
      </div>

      <div v-else-if="isGala && readyToShow"
           class="relative m-auto w-full min-h-[358px] rounded-[10px] shadow-zt flex flex-col max-w-[832px] xl:w-[832px]">
        <BonusDetailsModal v-if="bookieData && isModalOpen"
                           :bookieData="bookieData"
                           :isBookieDataLoaded="isBookieDataLoaded"
                           :isMainBonus="true"
                           :isInSidebar="Number(isInSidebar) === 1"
                           @close-modal="closeModal" />
        <div :data-bg-img="'url(/wp-content/themes/zawodtyper/assets/images/koszulki/' + bonusName + '.svg)'"
             class="!w-full h-[57px] !rounded-t-[10px] !rounded-b-[0px] bg-cover bg-center"></div>
        <div class="grow flex flex-col items-center bg-top rounded-b-[10px] bg-cover bg-no-repeat pt-4 pb-5 xl:pt-3 xl:pb-5"
             :class="{ 'justify-center': type === 'zawodtyper' }"
             :data-bg-img="'url(' + bonusBackground + ')'">
          <div v-if="type !== 'zawodtyper' && window.size.mobile"
               :data-bg-img="'url(/wp-content/themes/zawodtyper/assets/images/gale_logo/' + type + '.webp)'"
               class="!m-0 !w-[182px] h-[58px] bg-no-repeat bg-center"></div>
          <div v-else-if="type !== 'zawodtyper'"
               :data-bg-img="'url(/wp-content/themes/zawodtyper/assets/images/gale_logo/' + type + '.webp)'"
               class="m-0 !w-[230px] h-[72px] bg-no-repeat bg-center xl:mb-2.5"></div>
          <div class="text-[26px] min-h-[120px] flex font-medium leading-10 text-center items-center w-[95%] mx-auto
                      xl:min-h-0 xl:mx-0 xl:w-full xl:text-[32px] xl:leading-[44px]">
            <p class="mx-auto px-2 xl:leading-10" v-html="text"></p>
          </div>
          <a :href="bonusLink" :rel="newBetclicFameMMA ? 'follow' : 'nofollow'" target="_blank" @click="handleKoszulkaClick()"
             class="!no-underline no-default-style xl:mt-3.5 xl:mb-5">
            <div class="bg-white border border-dashed border-black rounded-zt font-medium text-[24px] relative w-[220px]
                   h-[44px] text-black text-center animation-pull-strip flex items-center justify-center xl:text-[32px]
                   xl:w-[268px] xl:h-[56px]"
                 :class="Number(isInSidebar) === 1 ? '!text-xl !w-[180px] !h-[44px]' : ''">
              {{ code }}
              <div class="absolute flex justify-center items-center -right-[2px] -top-[2px] bg-zt-red h-[calc(100%_+_4px)] w-1/2
                     transition-transform origin-right animation-pull-strip-wrapper rounded-r-[4px] shadow-zt hover:rounded-r-[6px]">
                <span class="triangle absolute bg-[#A01B29] h-full top-0 left-0 w-4 transition-transform origin-left shadow-zt"></span>
                <span class="text-sm text-white font-medium xl:text-lg"
                :class="Number(isInSidebar) === 1 ? '!text-sm' : ''"
                >ODKRYJ</span>
              </div>
            </div>
          </a>
          <div v-if="bookieData" class="relative flex justify-center items-center mt-3.5 xl:mt-0">
            <span class="text-center underline text-zt-more font-medium leading-[30px] zt-hover cursor-pointer"
                  @click="handleShowDetails(2)">POKAŻ SZCZEGÓŁY</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import BonusDetailsModal from '../../components/modals/BonusDetailsModal.vue';
import { countClicks } from '../../../assets/js/utils';

export default {
  name: 'BannerKoszulka',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: { BonusDetailsModal },
  inheritAttrs: {
    isTicketInSidebar: String,
    typ: String,
  },
  data() {
    let galasNames = {
      'famemma': 'Fame MMA',
      'ksw': 'KSW',
      'gromda': 'Gromda',
      'mmavip': 'MMA VIP',
      'primeshowmma': 'Prime Show MMA',
      'elitefighters': 'Elite Fighters',
      'move': 'MOVE',
      'ufc': 'UFC',
      'bellator': 'Bellator',
      'wotore': 'Wotore',
      'fen': 'FEN',
      'babilon': 'Babilon',
      'pfl': 'PFL',
      'cagewarriors': 'Cage Warriors',
      'oktagonmma': 'Oktagon MMA',
      'revolta': 'Revolta',
      'aresfc': 'Ares FC',
      'bravecf': 'Brave CF',
      'polsatboxingnight': 'Polsat Boxing Night',
      'solocombatfederation': 'Solo Combat Federation',
      'octagonfightleague': 'Octagon Fight League',
      'kingpyn': 'Kingpyn',
      'onefightnight': 'One Fight MMA',
      'cloutmma': 'Clout MMA',
      'zawodtyper': 'Zawód Typer',
      'bitasmietanka': 'Bita Śmietanka',
    };
    return {
      type: this.$attrs.typ ?? 'fortuna',
      link: this.$attrs.link ?? '',
      isGala: galasNames[this.$attrs.typ] ?? false,
      bookieData: [],
      text: '',
      code: '',
      bonusLink: '',
      bonusName: '',
      bonusBackground: '/wp-content/themes/zawodtyper/assets/images/tlo_koszulki_mecze.webp',
      fontColor: '',
      buttonColor: '',
      newBetclicFameMMA: this.$attrs.typ === 'famemma',
      readyToShow: false,
      isInSidebar: this.$attrs.isTicketInSidebar ?? this.$attrs.naglowek ?? 0,
      isModalOpen: false,
      isBookieDataLoaded: 0,
      rankingBukmacherowPageId: 36,
	    bookieCategoryIds: [775,767,776,765,781,771,764,768,762,779,766,777,774,773,763,780,769,770,778,772,851,850]
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    generatedId() {
      return this.type ? 'koszulka-' + this.type : 'bilet-' + this.bonusName;
    },
    analyticsAllowed() {
      if (this.type === this.bonusName) {
        return true;
      } else if (this.type === 'famemma' || this.type === 'ksw' || this.type === 'primeshowmma'
        || this.type === 'cloutmma') {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
		handleShowDetails(n) {
			this.openModal(this.generatedId);
			this.handleDetailsClick(n);
			if (this.bookieCategoryIds.includes(WP.categories[0]?.term_id) || this.bookieCategoryIds.includes(WP.categories[1]?.term_id)) {
				countClicks('Analityka buków II rzędu 3');
			}
		},
    getData() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_bookmaker_shirt',
        name: this.type,
      }).then(response => {
        if (response.data.success) {
          this.text = response.data.data.text;
          this.bonusName = response.data.data.bookmaker_name;
          this.code = response.data.data.code;
          this.bonusLink = this.link !== '' ? this.link : response.data.data.link;
          this.fontColor = response.data.data.button_text_color;
          this.buttonColor = response.data.data.button_color;
          if (response.data.data.background === 'stadium') {
            this.bonusBackground = '/wp-content/themes/zawodtyper/assets/images/tlo_koszulki_mecze.webp';
          } else if (response.data.data.background === 'fists') {
            this.bonusBackground = '/wp-content/themes/zawodtyper/assets/images/tlo_koszulki_gale.webp';
          } else {
            if (this.isGala) {
              this.bonusBackground = '/wp-content/themes/zawodtyper/assets/images/tlo_koszulki_gale.webp';
            }
          }
        }
        this.readyToShow = true;
        this.$nextTick(lazyLoad);
        this.getBookieData();
      });
    },
    getBookieData() {
      axios.get('/wp-json/acf/v3/pages/' + this.rankingBukmacherowPageId + '/sections').then(response => {
        const bookies = response.data.sections[0].bukmacherzy_legalni;
        this.bookieData = bookies.find(bookie => bookie.name.toLowerCase() === this.bonusName.toLowerCase());
        this.isBookieDataLoaded = 1;
      });
    },
    saveReceivedBonus() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_save_received_bonus',
        bookmaker: this.type,
        date: new Date(),
        type: 'user',
      })
      .then(response => {
        if (response.data.success) {
          socket?.emit('bonus-received', {
            bookmaker: this.type,
          });
        }
      });
    },
    clickHandler(link) {
	    if (this.bookieCategoryIds.includes(WP.categories[0]?.term_id) || this.bookieCategoryIds.includes(WP.categories[1]?.term_id)) {
		    countClicks('Analityka buków II rzędu 2');
	    }
	    if (this.WP.categories[0]?.cat_ID === 12) {
        if (this.analyticsAllowed) {
          countClicks('Nowy bilet i koszulka - Bilet 1');
        }
      } else if (this.type === 'zawodtyper') {
        countClicks('zt_ticket');
      } else if (this.analyticsAllowed) {
        countClicks('Nowy bilet i koszulka - Bilet 1');
      }
      window.open(link, '_blank');
    },
    openModal(elementId) {
      this.isModalOpen = true;
      this.blockScrolling();
      this.smoothScrollToElement(elementId, 33);
    },
    closeModal() {
      this.isModalOpen = false;
      this.unblockScrolling();
    },
    handleLogoClick() {
      countClicks('Pasek biletu').then(() => {
          window.open(this.bonusLink, '_blank');
      })
    },
    handleDetailsClick(option) {
      if (this.analyticsAllowed) {
        if (option === 1) {
          countClicks('Nowy bilet i koszulka - Bilet 2');
        } else if (option === 2) {
          countClicks('Nowy bilet i koszulka - Koszulka 2');
        }
      }
    },
    handleKoszulkaClick() {
      if (this.analyticsAllowed) {
        countClicks('Nowy bilet i koszulka - Koszulka 1');
      }
    }
  }
};
</script>

<style>
.animation-pull-strip {
  .animation-pull-strip-wrapper {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 10% 100%);
    .triangle {
      clip-path: polygon(0 0, 0% 100%,50% 100%, 100% 29%, 50% 0%);
    }
  }
  &:hover {
    .animation-pull-strip-wrapper {
      transform: scaleX(.75);
      background: #DE2D40;
    }
    .triangle {
      transform: scaleX(2);
    }
  }
}

.cut-corner {
  -webkit-clip-path: polygon(99% 0, 100% 19%, 100% 100%, 0 100%, 0 0);
  clip-path: polygon(99% 0, 100% 19%, 100% 100%, 0 100%, 0 0);
  @apply bg-cover;
}

.cut-corners {
    -webkit-clip-path: polygon(99% 0%, 100% 19%, 100% 81%, 99% 100%, 0% 100%, 0% 0%);
    clip-path: polygon(99% 0%, 100% 19%, 100% 95%, 99% 100%, 0% 100%, 0% 0%);
    @apply bg-cover;
}

.td-cut-corner {
  -webkit-clip-path: polygon(98.5% 0, 100% 19%, 100% 100%, 0 100%, 0 0);
  clip-path: polygon(98.5% 0, 100% 19%, 100% 100%, 0 100%, 0 0);
  @apply bg-cover;
}

.td-cut-corners {
  -webkit-clip-path: polygon(98.2% 0, 100% 5%, 100% 95%, 98.2% 100%, 0 100%, 0% 60%, 0 0);
  clip-path: polygon(98.2% 0, 100% 5%, 100% 95%, 98.2% 100%, 0 100%, 0% 60%, 0 0);
  @apply bg-cover;
}

@keyframes shine {
  10% {
    opacity: 1;
    top: 100%;
    left: 50%;
    transition-property: left, top, opacity;
    transition-duration: 1.3s, 1.3s, 0.15s;
    transition-timing-function: ease;
  }
  100% {
    opacity: 0;
    top: 100%;
    left: 50%;
    transition-property: left, top, opacity;
  }
}

.shine-animation:after {
  animation: shine 5s ease-in-out  infinite;
  animation-fill-mode: forwards;
  content: "";
  position: absolute;
  top: -140%;
  left: -50%;
  width: 120%;
  height: 100%;
  opacity: 0;
  transform: rotate(320deg);

  background: rgba(255, 255, 255, 0.13);
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.13) 0%,
    rgba(255, 255, 255, 0.13) 77%,
    rgba(255, 255, 255, 0.5) 92%,
    rgba(255, 255, 255, 0.33) 0%,
    rgba(255, 255, 255, 0.33) 77%,
    rgba(255, 255, 255, 0.7) 92%,
    rgba(255, 255, 255, 0.0) 100%
  );
}

.text-content strong, .text-content b {
    @apply font-semibold;
}
</style>